import '../../utilities/scrollIntoViewIfNeeded.js';
import { useTheme } from '@vebox/etui-system';
import '../../utilities/format-ms.js';
import '../../utilities/create-transition.js';
import { useContext, createElement } from 'react';
import '../../utilities/get-styleprop.js';
import '../../utilities/ellipsis.js';
import { _ as _objectWithoutProperties, b as _extends } from '../../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../../Svg-0180d7b5.js';
import '../../Icon/Icon.js';
import '@vebox/etui-icons';
import '../../Icon/icons.js';
import '../../Icon/helper.js';
import '@vebox/etui-colors';
import '../../ErrorLabel/ErrorLabel.js';
import '../../FormItem/FormItem.js';
import '../../InputLabel/InputLabel.js';
import '../../InputAddon/InputAddon.js';
import '../../ClickOutside/ClickOutside.js';
import '../../Tooltip/Tooltip.js';
import '../../Button/Button.js';
import '../state/constants.js';
import { setValue } from '../state/actions.js';
import FilterPanelContext from '../FilterPanelContext.js';
import ApplyFilterButton from './ApplyFilterButton.js';
import { C as ControlRow } from '../../styles-14c01051.js';
import 'react-select';
import '../../SelectInput/Control.js';
import '../../SelectInput/ValueContainer.js';
import '../../SelectInput/IndicatorsContainer.js';
import '../../SelectInput/DropdownIndicator.js';
import '../../SelectInput/ClearIndicator.js';
import '../../SelectInput/Menu.js';
import SelectInput from '../../SelectInput/SelectInput.js';

const _excluded = ["field", "isMulti", "showApplyButton", "applyButtonLabel"];
const SelectInputControl = _ref => {
  let {
      field,
      isMulti,
      showApplyButton = false,
      applyButtonLabel
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const theme = useTheme();
  const {
    state,
    dispatch
  } = useContext(FilterPanelContext);
  const emptyValue = isMulti ? [] : null;
  return /*#__PURE__*/createElement(ControlRow, null, /*#__PURE__*/createElement(SelectInput, _extends({
    key: field,
    name: field,
    isMulti: isMulti,
    value: state.toBeAppliedFilters[field] || emptyValue,
    styles: {
      root: {
        mb: `${theme.spacing.xs}px`,
        flex: 1
      }
    },
    searchable: true
  }, rest, {
    onChange: value => dispatch(setValue(field, value))
  })), showApplyButton && /*#__PURE__*/createElement(ApplyFilterButton, {
    field: field,
    applyButtonLabel: applyButtonLabel,
    styles: {
      root: {
        mb: `${theme.spacing.xs}px`
      }
    }
  }));
};

export default SelectInputControl;
